import { render } from "./ChatQuestionTemplateInput.vue?vue&type=template&id=66946824&scoped=true"
import script from "./ChatQuestionTemplateInput.vue?vue&type=script&lang=js"
export * from "./ChatQuestionTemplateInput.vue?vue&type=script&lang=js"

import "./ChatQuestionTemplateInput.vue?vue&type=style&index=0&id=66946824&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66946824"]])

export default __exports__